import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { useMaterialUIController } from "context";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";

import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import { displaySuccessMessage } from "controllers/validation";
import { getForms,getFormsByPagePermissions } from "controllers/MenuController";
import NewForm from "./components/NewForm";
import NewPage from "./components/NewPage";
import { deleteForm } from "controllers/MenuController";
import { deletePage } from "controllers/MenuController";
import { updatePageRowNumbers } from "controllers/MenuController";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  td: {
    height: 42,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let editId;
let editformType;
let editText;
let formId;
let editisSecretary = false;
function PageView(props) {
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [mode, setMode] = useState("new");
  const [search, setSearch] = useState("");
  const { headline, title, capsule } = useParams();

  const navigate = useNavigate();






  const handleDeleteFromClick = (id) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
      cancelButtonText: getText("cancel", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        setLoading(true);
        let data = await deleteForm(controller.lang, { id }, controller.token);
        setLoading(false);
        if (data.success) {
          displaySuccessMessage(
            controller.lang,
            getText("deletesuccessful", controller.lang)
          );
          handleClose();

          getData(search);
        } else {
          if (data.errorCode === 101) {
            navigate("/authentication/sign-in", { replace: true });
          } else {
            displayErrorMessage(controller.lang, data.message, data.code);
          }
        }
        setLoading(false);
      }
    });
  };




  const handleDeletePageClick = (id) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
      cancelButtonText: getText("cancel", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        setLoading(true);
        let data = await deletePage(controller.lang, { id }, controller.token);
        setLoading(false);
        if (data.success) {
          displaySuccessMessage(
            controller.lang,
            getText("deletesuccessful", controller.lang)
          );
          handleClose();

          getData(search);
        } else {
          if (data.errorCode === 101) {
            navigate("/authentication/sign-in", { replace: true });
          } else {
            displayErrorMessage(controller.lang, data.message, data.code);
          }
        }
        setLoading(false);
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setMode("new");
    setText("");
  };
  const searchHandler = (serachParam) => {
    getData(serachParam);
  };

  const handleDropRows = async (droppedItem, pages) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...pages];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    updatedList.map((item, index) => {
      item.rownumber = index + 1;
    });
    //updateCapsuleRowNumbers(controller.lang, updatedList, controller.token);
    await updatePageRowNumbers(controller.lang, updatedList, controller.token);
    console.log("updatedListupdatedList", updatedList);
    getData("");
  };

  useEffect(() => {
    if (!title || !headline || !capsule) {
      navigate(-1, { replace: true });
    }
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }
    if (title) {
      getData("");
    }
  }, [capsule]);
  const getData = async (searchx) => {
    try {
      setLoading(true);
      let newData = {
        search: searchx,
        lang: controller.lang,
        capsule: capsule,
      };

      let data = await getFormsByPagePermissions(controller.lang, newData, controller.token);
      setLoading(false);
      if (data.success) {
        setDatas(data.data);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };

  const renderPages = (pages, formParam, formTypeParam) => {
    return (
      <DragDropContext
        style={{
          width: "100%",
        }}
        onDragEnd={(item) => {
          handleDropRows(item, pages);
        }}
      >
        <Droppable droppableId="list-container">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <TableContainer
                style={{
                  height: pages.length * 43,
                }}
              >
                <Table size="larg" sx={{ minWidth: 500 }}>
                  <TableBody>
                    {pages.map((row, index) => (
                      <Draggable
                        key={row.id}
                        draggableId={row.id}
                        index={index}
                      >
                        {(provided) => (
                          <StyledTableRow
                            key={row.text}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#fff" : "#f2f2f2",
                            }}
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                          >
                            <TableCell
                              align="center"
                              component="th"
                              scope="row"
                              style={{ width: 20 }}
                            >
                              {row.rownumber}
                            </TableCell>
                            <TableCell>
                              <NavLink
                                to={
                                  formTypeParam == 4
                                    ? `/condition/${headline}/${title}/${capsule}/${formParam}/${row.id}/capsule/${formTypeParam}`
                                    : `/pagequestions/${headline}/${title}/${capsule}/${formParam}/${row.id}/${formTypeParam}`
                                }
                                //className={classes.item}
                                activeClassName="active"
                                key={index}
                              >
                                {row.text}
                              </NavLink>
                            </TableCell>
                            <TableCell align="center" style={{ width: 120 }}>
                              <div>
                                {/*   <Tooltip
                                  title={getText(
                                    "subformcondition",
                                    controller.lang
                                  )}
                                  aria-label="Condition"
                                  style={{
                                    paddingRight: 5,
                                    paddingLeft: 5,
                                    cursor: "pointer",
                                    fontSize: 18,
                                  }}
                                >
                                  <LowPriorityIcon
                                    style={{ width: 20, height: 20 }}
                                    color="secondary"
                                    onClick={() => {
                                      navigate(
                                        `/condition/${headline}/${title}/${capsule}/${formParam}/${row.id}/subform/${formTypeParam}`
                                      );
                                       
                                    }}
                                  />
                                </Tooltip>
                              <Tooltip
                                  title={getText(
                                    "sendcondition",
                                    controller.lang
                                  )}
                                  aria-label="sendcondition"
                                  style={{
                                    paddingRight: 5,
                                    paddingLeft: 5,
                                    cursor: "pointer",
                                    fontSize: 18,
                                  }}
                                >
                                  <CallMissedOutgoingIcon
                                    style={{ width: 20, height: 20 }}
                                    color="secondary"
                                    onClick={() => {
                                      navigate(
                                        `/condition/${headline}/${title}/${capsule}/${formParam}/${row.id}/coleague/coleague`
                                      );
                                    }}
                                  />
                                </Tooltip> */}
                                <Tooltip
                                  title={getText("edit", controller.lang)}
                                  aria-label="edit"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <ModeEditOutlineOutlinedIcon
                                    style={{ width: 20, height: 20 }}
                                    color="secondary"
                                    onClick={() => {
                                      editId = row.id;
                                      formId = formParam;
                                      editisSecretary = row.isSecretary;
                                      editText = row.text;
                                      setText("");
                                      setMode("editpage");
                                      handleClickOpen();
                                    }}
                                  />
                                </Tooltip>
                                {headline !== "scores" && (
                                  <Tooltip
                                    title={getText("delete", controller.lang)}
                                    aria-label="delete"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <HighlightOffIcon
                                      style={{ width: 20, height: 20 }}
                                      color="primary"
                                      onClick={() => {
                                        handleDeletePageClick(row.id);
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </div>
                            </TableCell>
                          </StyledTableRow>
                        )}
                      </Draggable>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };
  const convertFormTye = (value) => {
    switch (value) {
      case 1: {
        return "main";
      }
      case 2: {
        return "sub";
      }
      case 3: {
        return "help";
      }
      case 4: {
        return "result";
      }
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("pages", controller.lang)}
        searchHandler={searchHandler}
        showserch={true}
      />
      <MDBox pb={3}>
        <Card>
          <MDBox>
            <LoadingOverlay
              active={loading}
              spinner
              text={getText("loading", controller.lang)}
            >
              <TableContainer>
                <Table size="larg" sx={{ minWidth: 500 }}>
                  <TableBody>
                    <TableRow style={{ backgroundColor: "#ccc" }}>
                      <TableCell style={{ width: 60 }} align="center">
                        {getText("row", controller.lang)}
                      </TableCell>
                      <TableCell>{getText("text", controller.lang)}</TableCell>
                      <TableCell align={"flex-end"} style={{ width: 150 }}>
                        <Button
                          color="secondary"
                          onClick={() => {
                            setMode("newform");
                            setText("");
                            handleClickOpen();
                          }}
                        >
                          {getText("addnewpagecategory", controller.lang)}
                        </Button>
                      </TableCell>
                    </TableRow>
                    {datas.map((row, index) => (
                      <>
                        {!(headline !== "complaints" && row.formType == 4) && (
                          <>
                            <StyledTableRow
                              key={row.id}
                              style={{
                                backgroundColor: "#f7f7f7",
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                                style={{ width: 60 }}
                              >
                                {convertFormTye(row.formType)}
                              </TableCell>
                              <TableCell>
                                {/* <NavLink
                              to={"/admin/capsule/" + title + "/" + row.id}
                               activeClassName="active"
                              key={index}
                            > */}
                                {`${row.text}`}
                                {/* </NavLink> */}
                              </TableCell>
                              <TableCell align="center">
                                
                                {row.formType !== 4 && headline !== "scores" && (
                                  <Tooltip
                                    title={getText(
                                      "addnewpage",
                                      controller.lang
                                    )}
                                    aria-label="addpage"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <AddCircleOutlineIcon
                                      style={{ width: 20, height: 20 }}
                                      color="secondary"
                                      onClick={() => {
                                        formId = row.id;
                                        setMode("newpage");
                                        setOpen(true);
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                <Tooltip
                                  title={getText("edit", controller.lang)}
                                  aria-label="edit"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <ModeEditOutlineOutlinedIcon
                                    style={{ width: 20, height: 20 }}
                                    color="secondary"
                                    onClick={() => {
                                      editId = row.id;
                                      editformType = row.formType;
                                      editText = row.text;
                                      setMode("editform");
                                      setText("");
                                      handleClickOpen();
                                    }}
                                  />
                                </Tooltip>
                                {(row.formType == 2 || row.formType == 3) && (
                                  <Tooltip
                                    title={getText("delete", controller.lang)}
                                    aria-label="delete"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <HighlightOffIcon
                                      style={{ width: 20, height: 20 }}
                                      color="primary"
                                      onClick={() => {
                                        handleDeleteFromClick(row.id);
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </TableCell>
                            </StyledTableRow>
                            {row.pages.length > 0 && (
                              <StyledTableRow
                                key={row.name}
                                style={{
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  style={{ width: 60 }}
                                ></TableCell>
                                <TableCell colSpan={2}>
                                  {renderPages(row.pages, row.id, row.formType)}
                                </TableCell>
                              </StyledTableRow>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </LoadingOverlay>
          </MDBox>
        </Card>
      </MDBox>
      <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {mode.includes("page")
            ? mode === "newpage"
              ? getText("addnewpage", controller.lang)
              : getText("editpage", controller.lang)
            : mode === "newform"
            ? getText("addnewform", controller.lang)
            : getText("editform", controller.lang)}

          <HighlightOffIcon
            style={{
              width: 20,
              height: 20,
              float: controller.direction == "rtl" ? "left" : "right",
            }}
            color="primary"
            onClick={() => {
              handleClose();
            }}
          />
        </DialogTitle>
        <DialogContent>
          {(mode === "newform" || mode === "editform") && (
            <NewForm
              mode={mode}
              handleClose={handleClose}
              getData={getData}
              // form={formId}
              id={editId}
              capsule={capsule}
              formType={editformType}
              text={editText}
            />
          )}
          {(mode === "newpage" || mode === "editpage") && (
            <NewPage
              mode={mode}
              handleClose={handleClose}
              getData={getData}
              // userInfo={userInfo}
              form={formId}
              id={editId}
              isSecretary={editisSecretary}
              text={editText}
              capsule = {capsule}
            />
          )}
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}

export default PageView;
